// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ozmK","col":"styles_col__1WDiY","actions":"styles_actions__kLfsq","conflict":"styles_conflict__vB4bq"};